/**
 * 멤버 명함 (SPEC_CHANGE_v1.3 16.4, 시안 09 · 08 4장 C1 · C2, D53).
 *
 *   카드(--surface, hairline, 반경 16, 패딩 16, 세로 간격 12): 초상 56 + [이름 16/600 · 한 줄 소개 13/18]
 *   → 「이럴 때 불러」 판(--bg, 반경 12, 패딩 10 12: 라벨 12/600 --brand + 내용 14/22) → [1:1](주요) [프로필](보조)
 *
 * - 폭: 단독 294(말풍선 선 40 ~ 오른쪽 16) · 묶음 안 248. 카드 빈 곳을 누르면 프로필
 * - 2막 이모 소개 말 아래 묶음(가로 스냅) · 첫 주 차례의 단독 한 장에서 씁니다(대본 승인 뒤, C-21 나머지)
 * - 이모 명함(1막)은 이 틀과 따로입니다
 */
import { getMember } from '@config/members/index.js';
import { Avatar } from './Avatar.jsx';

export function MemberCard({ memberKey, inBundle = false, onChat, onProfile }) {
    const member = getMember(memberKey);
    if (!member?.card) {
        return null;
    }
    return (
        <article
            aria-label={`${member.name} 명함`}
            onClick={onProfile}
            className={`flex shrink-0 cursor-pointer snap-start flex-col gap-3 rounded-card border border-hairline bg-surface p-4 ${
                inBundle ? 'w-[248px]' : 'w-full max-w-[294px]'
            }`}
        >
            <div className="flex items-center gap-3">
                <Avatar memberKey={memberKey} size={56} />
                <div className="flex min-w-0 flex-col">
                    <span className="text-[16px] font-semibold">{member.name}</span>
                    <span className="text-[13px] leading-[18px] text-text-secondary">{member.card.intro}</span>
                </div>
            </div>
            <div className="flex flex-col gap-0.5 rounded-[12px] bg-bg px-3 py-2.5">
                <span className="text-[12px] font-semibold text-brand">이럴 때 불러</span>
                <span className="text-[14px] leading-[22px]">{member.card.callWhen}</span>
            </div>
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={(event) => {
                        event.stopPropagation();
                        onChat?.();
                    }}
                    className="h-10 flex-1 rounded-[12px] bg-brand text-[14px] font-semibold text-on-brand"
                >
                    1:1
                </button>
                <button
                    type="button"
                    onClick={(event) => {
                        event.stopPropagation();
                        onProfile?.();
                    }}
                    className="h-10 flex-1 rounded-[12px] border border-brand text-[14px] font-semibold text-brand"
                >
                    프로필
                </button>
            </div>
        </article>
    );
}

/** 명함 묶음: 왼쪽 40 에서 오른쪽 끝까지 가로 스냅, 다음 장이 약 30px 보입니다(08 결정 30). 점 · 숫자 표시 없음 */
export function MemberCardBundle({ memberKeys, onChat, onProfile }) {
    return (
        <div
            role="list"
            aria-label="멤버 명함"
            className="-mr-4 ml-10 flex snap-x snap-mandatory gap-2 overflow-x-auto pr-4 motion-reduce:snap-none"
        >
            {memberKeys.map((memberKey) => (
                <div key={memberKey} role="listitem" className="flex">
                    <MemberCard
                        memberKey={memberKey}
                        inBundle
                        onChat={() => onChat(memberKey)}
                        onProfile={() => onProfile(memberKey)}
                    />
                </div>
            ))}
        </div>
    );
}
